<div class="content">
    <div class="message" style="font-size: 15px"> 
       <p> <i class="tex">Khi cài đặt xác suất rơi quà là 0%, quà tặng vẫn có thể rơi ra nếu số lượng quà > 0 và các phần quà khác trong kịch bản đã hết.</i></p>
        <p><i>Để chắn chắn quà không rơi ra, vui lòng điều chỉnh số lượng quà bằng 0.</i></p>
        <label nz-checkbox [(ngModel)]="isChecked">Không hiển thị lại</label> 
    </div>
    <button class="btn-back" (click)="accept()">Tôi đã hiểu</button>
</div>